import {useCallback, useContext} from 'react';
import {useDispatch} from 'react-redux';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {setDeleteAccountStatus} from '@/src/app/store/user/deleteAccountSlice';

import PopupContext from '../../../popup/utils/PopupContext';
import DeleteAccountPopupLayout from '../components/DeleteAccountPopupLayout';
import requestDeleteAccount from '../utils/requestDeleteAccount';

const DeleteAccountPopup = () => {
  const {closePopup} = useContext(PopupContext);
  const dispatch = useDispatch();

  const handleCancelClick = useCallback(() => {
    closePopup();
  }, [closePopup]);

  const handleSubmitClick = useCallback(async ({remove_immediately}) => {
    const {status} = await requestDeleteAccount(!remove_immediately);

    if (status === RESPONSE_STATUSES.SUCCESS) {
      dispatch(setDeleteAccountStatus(true));
      closePopup();
    }
  }, []);

  return (
    <DeleteAccountPopupLayout
      onSubmitClick={handleSubmitClick}
      onCancelClick={handleCancelClick}
    />
  );
};

export default DeleteAccountPopup;
